<template>
  <b-card
    no-body
    :class="['sidebar__wrapper', isSidebarOpened ? 'opened' : '']"
  >
    <div slot="header">
      <b-form-input
        v-model="searchValue"
        placeholder="Filter fields"
        debounce="300"
      />
    </div>
    <b-card-body>
      <unrelated-fields :search-value="searchValue" />
    </b-card-body>
  </b-card>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import UnrelatedFields from '@/core/components/complex-table/UnrelatedFields.vue';

const {
  mapState: designerMapState,
  mapActions: designerMapActions,
} = createNamespacedHelpers('designer');
export default {
  name: 'DesignerSidebar',
  components: {UnrelatedFields},
  props: ['parentRef'],
  data() {
    return {
      isSearchbarOpened: false,
      searchValue: '',
    };
  },
  computed: {
    ...designerMapState({
      isSidebarOpened: state => state.isDesignerSidebarOpened,
    }),
  },
};
</script>

<style scoped lang="scss">
.sidebar__wrapper {
  transition: 0.3s;
  width: 0;
  border-left: 1px solid #eee;
  border-top: 1px solid #eee;
  height: 100%;

  &.opened {
    width: 100%;
  }
}

.card-body {
  height: 69vh;
  overflow-y: auto;
}

.header__main-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}
</style>